// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { doc, setDoc, getDoc } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCZkzz257zx-HwV4QPK6E3UktS6mD03FE4",
  authDomain: "daily-fishle.firebaseapp.com",
  projectId: "daily-fishle",
  storageBucket: "daily-fishle.firebasestorage.app",
  messagingSenderId: "3643679022",
  appId: "1:3643679022:web:5b4cf42221841805addabf",
  measurementId: "G-HKKDJ1ZNH9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize services
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

// SAVE DATA
export const saveUserData = async (userId, data) => {
  try {
    const userDoc = doc(db, "users", userId);
    await setDoc(userDoc, data, { merge: true });
  } catch (e) {
    console.error("Error saving document: ", e);
  }
};

// LOAD DATA
export const loadUserData = async (userId) => {
  try {
    const userDoc = doc(db, "users", userId);
    const docSnap = await getDoc(userDoc);
    if (docSnap.exists()) {
      return docSnap.data();
    }
    return null;
  } catch (e) {
    console.error("Error loading document: ", e);
    return null;
  }
};